import React from "react";
import { map } from "lodash";
import styled from "styled-components";
import { FontWeight, Spacing, border, content, dominant } from "@glossy";
import * as Tabs from "@radix-ui/react-tabs";

export const SIZES = {
  s: { px: Spacing.Medium },
  m: { px: Spacing.Large },
};

export interface IProps {
  tabs: { value: string; label: string; content?: React.ReactNode }[];
  defaultValue?: string;
  size?: keyof typeof SIZES;
  stretch?: boolean; // Stretch to fill the container horizontally
  onValueChange: (id: string) => void;
  className?: string;
}

const TabsList = styled(Tabs.List)`
  display: flex;
  border-bottom: 1px solid ${border};
`;

const TabsTrigger = styled(Tabs.Trigger)<{
  size: keyof typeof SIZES;
  stretch: string;
}>`
  white-space: nowrap;
  padding: 0 ${({ size }) => SIZES[size].px} 2px;
  cursor: pointer;
  line-height: 34px;
  background-color: transparent;
  color: ${(props) => content(props, "secondary")};
  flex: ${({ stretch }) => stretch === "true" && 1};
  text-align: center;
  margin-bottom: -1px;
  &[data-state="active"] {
    cursor: default;
    border-bottom: 2px solid ${dominant};
    padding-bottom: 1px;
    color: ${content};
    font-weight: ${FontWeight.Bold};
  }
  :hover {
    color: ${content};
  }
`;

const UiKitTabs = ({
  tabs,
  defaultValue,
  size = "m",
  stretch = true,
  onValueChange,
  className,
}: IProps) => (
  <Tabs.Root
    className={className}
    defaultValue={defaultValue}
    onValueChange={onValueChange}
  >
    <TabsList>
      {map(tabs, ({ value, label }) => (
        <TabsTrigger
          value={value}
          key={value}
          size={size}
          stretch={stretch.toString()}
        >
          {label}
        </TabsTrigger>
      ))}
    </TabsList>
    {map(
      tabs,
      ({ value, content }) =>
        content && (
          <Tabs.Content key={value} value={value}>
            {content}
          </Tabs.Content>
        )
    )}
  </Tabs.Root>
);

export default UiKitTabs;
